import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Banner from "./components/Banner";
import Planos from "./components/Planos";
import ControleNaPalma from "./components/ControleNaPalma";
import Comeceagora from "./components/ComeceAgora";
import OndeUsar from "./components/OndeUsar";
import NascemosParaFacilitar from "./components/NascemosParaFacilitar";
import TagVeloe from "./components/TagVeloe";
import { getComponent } from "../../store/ducks/component/actions";

// import './styles.scss'

const selector = (state) => ({
  component: state.component
});

export default function Parcerias(props) {
  const dispatch = useDispatch();
  const { component } = useSelector(selector);
  const { landingOrder, landingTitle } = component;

  useEffect(() => {
    (async () => {
      await dispatch(getComponent());
    })();
  }, [dispatch]);

  document.title = landingTitle;

  const pages = {
    landingHeader: function() {
      return <Banner />
    },
    landingDefaultPromo: function() {
      return <Planos />;
    },
    landingSimpleSection: function() {
      return <ControleNaPalma />;
    },
    landingStepperSection: function() {
      return <Comeceagora />;
    },
    landingMapa: function() {
      return <OndeUsar />;
    },
    landingDoubleSection: function() {
      return <NascemosParaFacilitar />;
    },
    landingSecaoTagVeloe: function() {
      return <TagVeloe />;
    }
  }

  return (
    <>
      {landingOrder.map((x) => pages[x.value] ? pages[x.value]() : '')}
    </>
  );
}
